/* === OMC Lightbox — clean product image zoom & gallery === */
(function () {
  'use strict';

  var MAX_SCALE = 4;
  var CLICK_ZOOM = 2.5;

  var state = { images: [], index: 0, scale: 1, tx: 0, ty: 0, open: false };
  var els = null;

  function baseUrl(src) { return src.split('?')[0]; }
  function sized(src, w) {
    var b = src.split('?');
    var params = new URLSearchParams(b[1] || '');
    params.set('width', String(w));
    return b[0] + '?' + params.toString();
  }

  function collectImages() {
    var seen = {};
    var list = [];
    var imgs = document.querySelectorAll('media-gallery .product-media-container img.product-media__image, media-gallery .product-media img');
    imgs.forEach(function (img) {
      var src = img.currentSrc || img.src;
      if (!src) return;
      var key = baseUrl(src);
      if (seen[key]) return;
      seen[key] = true;
      list.push({ full: sized(src, 2048), thumb: sized(src, 120) });
    });
    return list;
  }

  function svg(path) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + path + '</svg>'; }

  function build() {
    var lb = document.createElement('div');
    lb.className = 'omc-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-label', 'Image gallery');
    lb.innerHTML =
      '<div class="omc-lightbox__stage"><img class="omc-lightbox__img" alt="Product image"></div>' +
      '<span class="omc-lightbox__counter"></span>' +
      '<button class="omc-lightbox__close" aria-label="Close">' + svg('<path d="M6 6l12 12M18 6L6 18"/>') + '</button>' +
      '<button class="omc-lightbox__nav omc-lightbox__nav--prev" aria-label="Previous image">' + svg('<path d="M15 5l-7 7 7 7"/>') + '</button>' +
      '<button class="omc-lightbox__nav omc-lightbox__nav--next" aria-label="Next image">' + svg('<path d="M9 5l7 7-7 7"/>') + '</button>' +
      '<div class="omc-lightbox__zoom-controls">' +
        '<button data-zoom="out" aria-label="Zoom out">' + svg('<path d="M5 12h14"/>') + '</button>' +
        '<button data-zoom="in" aria-label="Zoom in">' + svg('<path d="M12 5v14M5 12h14"/>') + '</button>' +
      '</div>' +
      '<div class="omc-lightbox__thumbs"></div>' +
      '<span class="omc-lightbox__hint">Click to zoom &middot; drag to pan &middot; arrows to browse</span>';
    document.body.appendChild(lb);

    els = {
      lb: lb,
      stage: lb.querySelector('.omc-lightbox__stage'),
      img: lb.querySelector('.omc-lightbox__img'),
      counter: lb.querySelector('.omc-lightbox__counter'),
      thumbs: lb.querySelector('.omc-lightbox__thumbs')
    };

    lb.querySelector('.omc-lightbox__close').addEventListener('click', close);
    lb.querySelector('.omc-lightbox__nav--prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.omc-lightbox__nav--next').addEventListener('click', function () { go(1); });
    lb.querySelector('[data-zoom="in"]').addEventListener('click', function () { zoomTo(state.scale + 0.75); });
    lb.querySelector('[data-zoom="out"]').addEventListener('click', function () { zoomTo(state.scale - 0.75); });

    els.stage.addEventListener('click', function (e) {
      if (e.target === els.stage) close();
    });

    var moved = false;
    els.img.addEventListener('click', function (e) {
      if (moved) return;
      if (state.scale > 1) zoomTo(1);
      else zoomAt(CLICK_ZOOM, e.clientX, e.clientY);
    });

    els.stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var next = state.scale * (e.deltaY < 0 ? 1.15 : 0.87);
      zoomAt(next, e.clientX, e.clientY);
    }, { passive: false });

    var pointers = {};
    var start = null;
    var pinchStart = null;

    els.img.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      moved = false;
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStart = { dist: Math.hypot(a.x - b.x, a.y - b.y), scale: state.scale };
      } else {
        start = { x: e.clientX, y: e.clientY, tx: state.tx, ty: state.ty };
        if (state.scale > 1) els.img.classList.add('is-panning');
      }
      els.img.setPointerCapture(e.pointerId);
    });

    els.img.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2 && pinchStart) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt(pinchStart.scale * (d / pinchStart.dist), (a.x + b.x) / 2, (a.y + b.y) / 2);
        moved = true;
        return;
      }
      if (!start) return;
      var dx = e.clientX - start.x;
      var dy = e.clientY - start.y;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
      if (state.scale > 1) {
        state.tx = start.tx + dx;
        state.ty = start.ty + dy;
        clampPan();
        applyTransform();
      }
    });

    function endPointer(e) {
      var wasSwipe = start && state.scale === 1;
      var dx = wasSwipe ? e.clientX - start.x : 0;
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) pinchStart = null;
      if (Object.keys(pointers).length === 0) {
        els.img.classList.remove('is-panning');
        if (wasSwipe && Math.abs(dx) > 60) go(dx < 0 ? 1 : -1);
        start = null;
      }
    }
    els.img.addEventListener('pointerup', endPointer);
    els.img.addEventListener('pointercancel', endPointer);

    els.img.addEventListener('dblclick', function (e) {
      e.preventDefault();
      if (state.scale > 1) zoomTo(1);
      else zoomAt(CLICK_ZOOM, e.clientX, e.clientY);
    });

    document.addEventListener('keydown', function (e) {
      if (!state.open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === '+' || e.key === '=') zoomTo(state.scale + 0.5);
      else if (e.key === '-') zoomTo(state.scale - 0.5);
    });
  }

  function clampPan() {
    var r = els.img.getBoundingClientRect();
    var maxX = Math.max(0, (r.width - window.innerWidth) / 2 + 80);
    var maxY = Math.max(0, (r.height - window.innerHeight) / 2 + 80);
    state.tx = Math.min(maxX, Math.max(-maxX, state.tx));
    state.ty = Math.min(maxY, Math.max(-maxY, state.ty));
  }

  function applyTransform() {
    els.img.style.transform = 'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.scale + ')';
    els.img.classList.toggle('is-zoomed', state.scale > 1);
  }

  function zoomTo(scale) {
    state.scale = Math.min(MAX_SCALE, Math.max(1, scale));
    if (state.scale === 1) { state.tx = 0; state.ty = 0; }
    else clampPan();
    applyTransform();
  }

  function zoomAt(scale, cx, cy) {
    var prev = state.scale;
    var next = Math.min(MAX_SCALE, Math.max(1, scale));
    if (next === 1) { state.scale = 1; state.tx = 0; state.ty = 0; applyTransform(); return; }
    var r = els.img.getBoundingClientRect();
    var ox = cx - (r.left + r.width / 2);
    var oy = cy - (r.top + r.height / 2);
    var f = next / prev;
    state.tx = state.tx - ox * (f - 1);
    state.ty = state.ty - oy * (f - 1);
    state.scale = next;
    clampPan();
    applyTransform();
  }

  function render() {
    var item = state.images[state.index];
    if (!item) return;
    state.scale = 1; state.tx = 0; state.ty = 0;
    els.img.classList.add('is-switching');
    var pre = new Image();
    pre.onload = function () {
      els.img.src = item.full;
      applyTransform();
      els.img.classList.remove('is-switching');
    };
    pre.onerror = function () {
      els.img.src = item.full;
      els.img.classList.remove('is-switching');
    };
    pre.src = item.full;
    els.counter.textContent = (state.index + 1) + ' / ' + state.images.length;
    els.thumbs.querySelectorAll('button').forEach(function (b, i) {
      b.classList.toggle('is-active', i === state.index);
    });
    var single = state.images.length < 2;
    els.lb.querySelectorAll('.omc-lightbox__nav').forEach(function (n) {
      n.style.display = single ? 'none' : '';
    });
    els.thumbs.style.display = single ? 'none' : '';
    els.counter.style.display = single ? 'none' : '';
  }

  function renderThumbs() {
    els.thumbs.innerHTML = '';
    state.images.forEach(function (item, i) {
      var b = document.createElement('button');
      b.setAttribute('aria-label', 'View image ' + (i + 1));
      var im = document.createElement('img');
      im.src = item.thumb;
      im.alt = '';
      b.appendChild(im);
      b.addEventListener('click', function () {
        state.index = i;
        render();
      });
      els.thumbs.appendChild(b);
    });
  }

  function go(dir) {
    var n = state.images.length;
    if (n < 2) return;
    state.index = (state.index + dir + n) % n;
    render();
  }

  function open(index) {
    state.images = collectImages();
    if (!state.images.length) return false;
    state.index = Math.min(Math.max(0, index), state.images.length - 1);
    if (!els) build();
    renderThumbs();
    render();
    els.lb.style.display = 'flex';
    document.body.classList.add('omc-lightbox-open');
    state.open = true;
    void els.lb.offsetHeight;
    els.lb.classList.add('is-open');
    return true;
  }

  function close() {
    state.open = false;
    els.lb.classList.remove('is-open');
    document.body.classList.remove('omc-lightbox-open');
    setTimeout(function () { els.lb.style.display = 'none'; }, 250);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('media-gallery .product-media-container__zoom-button, media-gallery .product-media-container');
    if (!trigger) return;
    var container = trigger.closest('.product-media-container') || trigger;
    var img = container.querySelector('img');
    if (!img) return;
    var key = baseUrl(img.currentSrc || img.src);
    var imgs = collectImages();
    var idx = 0;
    imgs.forEach(function (item, i) {
      if (baseUrl(item.full) === key) idx = i;
    });
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    state.images = imgs;
    open(idx);
    closeFloraDialog();
    setTimeout(closeFloraDialog, 0);
    setTimeout(closeFloraDialog, 100);
  }, true);

  function closeFloraDialog() {
    document.querySelectorAll('dialog.dialog-zoomed-gallery__dialog').forEach(function (d) {
      try { if (d.open) d.close(); } catch (err) {}
    });
  }
})();
